module.exports = __webpack_public_path__ + "img/log_dark_3.5a25acac.png";